// extracted by mini-css-extract-plugin
export var menuWrapper = "menu-module--menuWrapper--jifQe";